import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useReorderQuoteRequestLines } from "#modules/quoteRequestLines/view/useReorderQuoteRequestLines";
import {
  computeQuoteRequestLineNameSortOrderedIds,
  detectQuoteRequestLineSort,
  QuoteRequestLineNameSortDirection,
} from "#modules/quoteRequestLinesV2/domain/sortQuoteRequestLinesByName";

export const useQuoteRequestLinesSort = (
  quoteRequestId: string | undefined,
  quoteRequestLines: (QuoteRequestLineDto | null | undefined)[],
) => {
  const { reorderQuoteRequestLines } = useReorderQuoteRequestLines({ quoteRequestId });

  const lines = quoteRequestLines.filter((line): line is QuoteRequestLineDto => Boolean(line));

  const activeSort = detectQuoteRequestLineSort(lines);

  const applySort = (direction: QuoteRequestLineNameSortDirection) => {
    if (!quoteRequestId) {
      return;
    }
    reorderQuoteRequestLines({
      quoteRequestId,
      orderedIds: computeQuoteRequestLineNameSortOrderedIds(lines, direction),
    });
  };

  return { activeSort, applySort };
};
